import { checkDingDing, checkUpstreamConfig } from "@/service/appList";
export default {
  name: "AppDetailTab4",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      success: false,
      showTip: false
    };
  },
  computed: {
    // 自己钉钉
    _isDingDing() {
      return this.detail.appId === "DING_TALK_SYNC";
    },
    // 第三方钉钉
    _isThirdDingDing() {
      return this.detail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE";
    },
    // 企业微信通讯录同步应用
    _isEnterpriseWechatSync() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // 上游系统标识
    _upstream() {
      let value = "";
      if (this._isThirdDingDing) {
        value = "DING_TALK";
      } else if (this._isEnterpriseWechat || this._isEnterpriseWechatSync) {
        value = "WE_CHAT_WORK_PRIVATE";
      }
      return value;
    }
  },
  methods: {
    check() {
      if (this._isDingDing) {
        this.dingding();
      } else {
        this.dingdingThird();
      }
    },
    /*
     * 钉钉通讯录
     */
    async dingding() {
      const res = await checkDingDing();
      if (res.data && res.data.result == 0) {
        this.success = true;
      }
      this.showTip = true;
    },
    /*
     * 钉钉/企业微信第三方
     */
    async dingdingThird() {
      // 同步应用只校验自身凭据，避免复用普通企微应用的配置。
      const appId = this._isEnterpriseWechatSync ? this.detail.appId : undefined;
      const res = await checkUpstreamConfig(this._upstream, appId);
      if (res.data && res.data.result == 0) {
        this.success = true;
      }
      this.showTip = true;
    }
  }
};